import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import dashboard from './modules/dashboard'
import context from './modules/context'
import task from './modules/task'
import coding from './modules/coding'
import vismem from './modules/vismem'
import vm from './modules/vm'
// import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    user: {
      'consent_given_at': null,
      'userId': null,
      'wants_result_summary': null,
      'result_summary': null,
      'urt': null
    }
  },
  modules: {
    dashboard,
    context,
    task,
    coding,
    vismem,
    vm
  },
  actions: {
    setUser: ({commit}, payload) => {
      commit('SET_USER', payload)
    },
    setUserUrt: ({commit}) => {
      commit('SET_USER_URT')
    },
    clearState: ({commit}, payload) => {
      commit('CLEAR_STATE')
    }
  },
  getters: {
    getUserId: state => {
      return state.user.userId
    },
    getResultSummary: state => {
      return state.user.result_summary
    }
  },
  mutations: {
    'SET_USER' (state, user) {
      state.user = user
    },
    'SET_USER_URT' (state) {
      state.user.urt = true
    },
    'CLEAR_STATE' (state) {
      state.user = {
        'consent_given_at': null,
        'userId': null,
        'wants_result_summary': null,
        'result_summary': null,
        'urt': null
      }
      state.dashboard = {
        'currentComponent': 'consent'
      }
      state.context = {
        'contextState': {
          'consent': {
            'component': 'Consent',
            'consentStatus': false,
            'consentTimestamp': '',
            'completed': false
          },
          'audiocheck': {
            'component': 'AudioCheck',
            'completed': false
          },
          'questions': {
            'component': 'Rules',
            'answers': '',
            'completed': false
          },
          'task': {
            'component': 'Task',
            'completed': false
          },
          'done': {
            'component': 'Done',
            'responses': '',
            'completed': false
          },
          'feedback': {
            'component': 'Feedback',
            'feedback': '',
            'completed': false
          },
          'resultsummary': {
            'component': 'Resultsummary',
            'feedback': '',
            'completed': false
          },
          'logout': {
            'component': 'Logout',
            'completed': false
          },
          'currentContext': 'consent'
        }
      }
      state.task = {
        'taskStates': [
          {
            'id': 1,
            'task': 'srt',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 2,
            'task': 'mst',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 3,
            'task': 'vismem',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 4,
            'task': 'vm',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 5,
            'task': 'cod',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 6,
            'task': 'dsf',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 7,
            'task': 'vismem',
            'taskComponent': 'delayed',
            'status': 'clean'
          },
          {
            'id': 8,
            'task': 'dsb',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 9,
            'task': 'vm',
            'taskComponent': 'delayed',
            'status': 'clean'
          },
          {
            'id': 10,
            'task': 'crt',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 11,
            'task': 'pvt',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 12,
            'task': 'iqt',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 13,
            'task': 'ptr',
            'taskComponent': 'instruction',
            'status': 'clean'
          },
          {
            'id': 14,
            'task': 'done',
            'taskComponent': 'instruction',
            'status': 'clean'
          }
        ],
        'currentTaskIndex': '',
        'currentTask': '',
        'currentTaskComponent': '',
        'currentResultId': null,
        'userAbortStatus': false
      }
      state.coding = {
        'codingKey': ''
      }
      state.vismem = {
        'initialPositions': ''
      }
      state.vm = {
        'wordList': ''
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js